export default __webpack_public_path__ + "static/media/separator-6.d6d64802.svg";